@if (showOfflineMessage$ | async) {
  <div class="message">
    <mat-icon>cloud_off</mat-icon>
    You are offline! Please, check your internet connection.
  </div>
}
